<template>
  <button
    :type="buttonType"
    :class="classes"
    >
    <span class="btn__spinner">
      <span></span>
    </span>
    <span class="btn__content">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'dx-avatar',
  props: {
    buttonType: {
      type: String,
      default: 'button'
    },
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    warning: Boolean,
    danger: Boolean,
    info: Boolean,
    default: Boolean,
    link: Boolean,
    loading: Boolean,
    small: Boolean,
    large: Boolean
  },
  computed: {
    classes () {
      return {
        'btn': true,
        'btn-primary': this.primary,
        'btn-secondary': this.secondary,
        'btn-success': this.success,
        'btn-danger': this.danger,
        'btn-warning': this.warning,
        'btn-info': this.info,
        'btn-link': this.link,
        'btn-default': this.default,
        'disabled': this.loading,
        'btn--loading': this.loading,
        'btn-sm': this.small,
        'btn-lg': this.large
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxButton.vue